<!-- 课程首页 -->
<template>
  <div class="el-CourseHome">
    <el-row class="content_block mb20 p20 head_course">
      <el-col :span="8">
        <el-image class="user_img" :src="user"></el-image>
        <p class="xm fontB">姓名：{{userInfo.studentName}}</p>
        <p class="gh_skm">学号：{{userInfo.studentSn}}</p>
        <p class="gh_skm" v-if="tag != 1">
          课程授权码：{{courseInfo.teacherInfo.teacherOpenCourseMergeTeacherAuthCode}}
          <el-image style="width: 18px;margin-bottom: -2px;margin-left: 20px;cursor: pointer;" @click="copyNo" :src="fuzhi"></el-image>
        </p>
      </el-col>
      <el-col :span="16" v-if="tag != 1">
        <ul>
          <li style="background-color: #F3F7FA;" @click="onShow(11)">
            <el-badge :value="UnreadNotice" class="item">
              <el-image class="head_img" :src="tongzhi"></el-image>
            </el-badge>
            <p class="">通知公告</p>
          </li>
          <li style="background-color: #F3F7FA;" @click="onShow(10)">
            <el-image class="head_img" :src="zhishi"></el-image>
            <p class="">知识管理</p>
          </li>
          <li style="background-color: #F3F7FA;" @click="onShow(6,'tab_2')">
            <el-badge :value="UnreadXstw" class="item">
              <el-image class="head_img" :src="xstw"></el-image>
            </el-badge>
            <p class="">学生提问</p>
          </li>
          <li style="background-color: #F3F7FA;" @click="onShow(6,'tab_3')">
            <el-badge :value="UnreadTiwen" class="item">
              <el-image class="head_img" :src="tiwen"></el-image>
            </el-badge>
            <p class="">老师提问</p>
          </li>
        </ul>
      </el-col>
    </el-row> 
    <el-row class="content_block mb20 p20">
      <el-button :type="on_show==0?'primary':'plain'" class="mb20" @click="onShow(0)">
        <el-image class="content_img" style="float: left;" :src="on_show==0?ziye:ziye_f"></el-image>首页
      </el-button>
      <template  v-if="tag != 1">
        <el-button :type="on_show==1?'primary':'plain'" class="mb20" @click="onShow(1)">
          <el-image class="content_img" style="float: left;" :src="on_show==1?kb_b:kb"></el-image>课表
        </el-button>
        <el-button :type="on_show==2?'primary':'plain'" class="mb20" @click="onShow(2)">
          <el-image class="content_img" style="float: left;" :src="on_show==2?qiandao_b:qiandao"></el-image>签到
        </el-button>
        <el-button :type="on_show==3?'primary':'plain'" class="mb20" @click="onShow(3)">
          <el-image class="content_img" style="float: left;" :src="on_show==3?kcheng_b:kcheng"></el-image>课程设置
        </el-button>
        <el-button :type="on_show==4?'primary':'plain'" class="mb20" @click="onShow(4)">
          <el-image class="content_img" style="float: left;" :src="on_show==4?zjie_b:zjie"></el-image>章节练习
        </el-button>
        <el-button :type="on_show==5?'primary':'plain'" class="mb20" @click="onShow(5)">
          <el-image class="content_img" style="float: left;" :src="on_show==5?caozuo_b:caozuo"></el-image>课程实操
        </el-button>
        <el-button :type="on_show==6?'primary':'plain'" class="mb20" @click="onShow(6,'tab_1')">
          <el-image class="content_img" style="float: left;" :src="on_show==6?hudongliaotian_b:hudongliaotian"></el-image>互动
        </el-button>
        <el-button :type="on_show==7?'primary':'plain'" class="mb20" @click="onShow(7)">
          <el-image class="content_img" style="float: left;" :src="on_show==7?zuoye_b:zuoye"></el-image>作业
        </el-button>
        <el-button :type="on_show==8?'primary':'plain'" class="mb20" @click="onShow(8)">
          <el-image class="content_img" style="float: left;" :src="on_show==8?kaoshi_2_b:kaoshi_2"></el-image>考试
        </el-button>
        <el-button :type="on_show==9?'primary':'plain'" class="mb20" @click="onShow(9)">
          <el-image class="content_img" style="float: left;" :src="on_show==9?cz_dftj_b:cz_dftj"></el-image>成绩
        </el-button>
        <el-button :type="on_show==10?'primary':'plain'" class="mb20" @click="onShow(10)">
          <el-image class="content_img" style="float: left;" :src="on_show==10?ktzsd_b:ktzsd"></el-image>课堂知识点
        </el-button>
      </template>
      <template v-else>
        <el-button :type="on_show==3?'primary':'plain'" class="mb20" @click="onShow(3)">
          <el-image class="content_img" style="float: left;" :src="on_show==3?kcheng_b:kcheng"></el-image>课程设置
        </el-button>
        <!-- <el-button :type="on_show==4?'primary':'plain'" class="mb20" @click="onShow(4)">
          <el-image class="content_img" style="float: left;" :src="on_show==4?zjie_b:zjie"></el-image>章节练习
        </el-button>
        <el-button :type="on_show==5?'primary':'plain'" class="mb20" @click="onShow(5)">
          <el-image class="content_img" style="float: left;" :src="on_show==5?caozuo_b:caozuo"></el-image>课程实操
        </el-button> -->
        <el-button :type="on_show==10?'primary':'plain'" class="mb20" @click="onShow(10)">
          <el-image class="content_img" style="float: left;" :src="on_show==10?ktzsd_b:ktzsd"></el-image>课堂知识点
        </el-button>
      </template>
      <course-index :courseId="courseId+''" v-if="on_show == 0"></course-index>
      <Timetable :courseId="courseId+''" v-if="on_show == 1"></Timetable>
      <SignIn :courseId="courseId+''" v-if="on_show == 2"></SignIn>
      <SetUp :courseId="courseId+''" v-if="on_show == 3"></SetUp>
      <Practice :courseId="courseId+''" v-if="on_show == 4"></Practice>
      <PracticalTraining :courseId="courseId+''" :courseInfoName="courseInfo.teacherOpenCourseTitle" v-if="on_show == 5"></PracticalTraining>
      <Discuss :courseId="courseId+''" :teacherOpenCourseChatLogId='teacherOpenCourseChatLogId' v-if="on_show == 6" @onSuccess_t="getTeacherAskUnReadCount" :active="tabInfo"></Discuss>
      <Homework :courseId="courseId+''" v-if="on_show == 7"></Homework>
      <ExamList :courseId="courseId+''" v-if="on_show == 8"></ExamList>
      <ScoreInfo :courseId="courseId+''" v-if="on_show == 9"></ScoreInfo>
      <KnowledgePoints :courseId="courseId+''" v-if="on_show == 10"></KnowledgePoints>
      <Notice :courseId="courseId+''" @onSuccess="getUnreadNotice" v-if="on_show == 11"></Notice>
    </el-row>
  </div>
</template>

<script>
import courseIndex from "./components/index"; //课程首页
import Timetable from "./components/Timetable"; //课表
import SignIn from "./components/SignIn"; //签到
import SetUp from "./components/SetUp"; //课程设置
import Practice from "./components/Practice"; //章节练习
import Discuss from "./components/Discuss"; //互动
import Homework from "./components/Homework"; //作业
import ExamList from "./components/ExamList"; //考试
import Notice from "./components/Notice"; //通知公告
import ScoreInfo from "./components/ScoreInfo"; //成绩
import KnowledgePoints from "./components/KnowledgePoints"; //知识点管理
import PracticalTraining from "./components/PracticalTraining/PracticalTraining"; //课程实操
import {getTeacherAskUnReadCount,getStudentAskUnReadCount} from "@/common/getInfo.js";
export default {
  name: "MyCourse",
  components: {
  	courseIndex,
    Timetable,
    SignIn,
    SetUp,
    Practice,
    Discuss,
    Homework,
    ExamList,
    Notice,
    PracticalTraining,
    ScoreInfo,
    KnowledgePoints,
  },
  data() {
    return {
      fuzhi:require("../../images/course/fuzhi@2x.png"),
      ziye_f:require("../../images/course/zhuye@2x.png"),
      tongzhi:require("../../images/course/tongzhi@2x.png"),
      zhishi:require("../../images/course/zhishi@2x.png"),
      tiwen:require("../../images/course/tiwen@2x.png"),
      xstw:require("../../images/course/xstw@2x.png"),
      ziye:require("../../images/course/ziye@2x.png"),
      kcheng:require("../../images/course/kcheng@2x.png"),
      kcheng_b:require("../../images/course/kecheng@2x.png"),
      zjie:require("../../images/course/zjie@2x.png"),
      caozuo:require("../../images/course/caozuo@2x.png"),
      caozuo_b:require("../../images/course/caozuo_b@2x.png"),
      ktzsd:require("../../images/course/ktzsd@2x.png"),
      ktzsd_b:require("../../images/course/ktzsd_b@2x.png"),
      kb:require("../../images/course/kb@2x.png"),
      kb_b:require("../../images/course/kb_b@2x.png"),
      qiandao:require("../../images/course/qiandao-xianxing@2x.png"),
      qiandao_b:require("../../images/course/qiandao-xianxing_b@2x.png"),
      hudongliaotian:require("../../images/course/hudongliaotian@2x.png"),
      hudongliaotian_b:require("../../images/course/hd_b@2x.png"),
      zuoye:require("../../images/course/task@2x.png"),
      zuoye_b:require("../../images/course/task_b@2x.png"),
      zjie_b:require("../../images/course/zj_b@2x.png"),
      kaoshi_2:require("../../images/course/kaoshi@2x_2.png"),
      kaoshi_2_b:require("../../images/course/kaoshi-b@2x.png"),
      cz_dftj:require("../../images/course/cz-dftj@2x.png"),
      cz_dftj_b:require("../../images/course/cj-b@2x.png"),
      user:this.$getHeadImg(),
      on_show:this.$ls.get(this.$getKeyInfo('on_show')) || 0,
      tabInfo:"tab_1",
      courseInfo:{
        teacherInfo:{}
      },
      userInfo:this.$ls.get(this.$getKeyInfo("identityInfo")) || {},
      teacherOpenCourseChatLogId:null,
      courseId:"",
      UnreadNotice:null,//通知公告
      UnreadXstw:null,//学生提问
      UnreadTiwen:null,//教师提问
      tag:null,
      timeIn:null
    };
  },
  created() {
    if(!this.$isEmpty(this.$route.query.teacherOpenCourseId)){
      this.courseId = this.$route.query.teacherOpenCourseId;
      this.tag = this.$route.query.index;
      this.getInfo();
      //this.addSystem();
    }else{
      this.$message({message: '课程信息丢失！',type: 'warning'});
      let this_ = this;
      setTimeout(function(){
        this_.$router.go(-1);
      },500);
    }
    if(!this.$isEmpty(this.$route.query.teacherOpenCourseChatLogId)){
      this.teacherOpenCourseChatLogId = this.$route.query.teacherOpenCourseChatLogId;
    }
  },
  mounted() {
    // this.getInfo();
    this.getUnreadNotice();
    this.getTeacherAskUnReadCount();
    this.getStudentAskUnReadCount();
  },
  methods: {
    getUnreadNotice(){
      this.$get("/api/teacherOpenCourseNotice/getUnreadNotice",{teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.UnreadNotice = ret.data || null;
          }else{
            this.UnreadNotice = null;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getTeacherAskUnReadCount(){
      getTeacherAskUnReadCount({teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.UnreadTiwen = ret.data || null;
          }else{
            this.UnreadTiwen = null;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getStudentAskUnReadCount(){
      getStudentAskUnReadCount({teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.UnreadXstw = ret.data || null;
          }else{
            this.UnreadXstw = null;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getInfo(){
      this.$get("/jlw/teacherOpenCourse/view.json",{teacherOpenCourseId:this.courseId}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.courseInfo = ret.data;
            this.$ls.set(this.$getKeyInfo("logName"),this.courseInfo.teacherOpenCourseTitle); //用于使用记录
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    onShow(index,tabInfo){
      this.on_show = index;
      this.tabInfo = tabInfo;
      this.$ls.set(this.$getKeyInfo('on_show'),index);
      if(index == 6 && tabInfo == "tab_2"){
        this.getStudentAskUnReadCount();
      }else if(tabInfo == "tab_3"){
        this.getTeacherAskUnReadCount();
      }else if(tabInfo == "tab_1"){
        this.getStudentAskUnReadCount();
        this.getTeacherAskUnReadCount();
      }
    },
    copyNo() { //复制
      var input = document.createElement("input"); // 创建input对象
      input.value = this.courseInfo.teacherInfo.teacherOpenCourseMergeTeacherAuthCode; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message({message:"复制成功",type:'success'});
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"课程中心",//一级名称
          secondName:this.courseInfo.teacherOpenCourseTitle,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-CourseHome{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .head_course{
      ul{
        list-style-type:none;
        margin: 0;
        padding: 0;
      }
      li{
        width: 120px;
        float: left;
        margin-right: 8%;
        text-align: center;
        padding: 10px;
        .head_img{
          width: 50px;
          height: 50px;
        }
        p{
          margin: 10px 0 0;
        }
        cursor: pointer;
      }
      .user_img{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        float: left;
        margin-right: 20px;
      }
      .gh_skm,.xm{
        margin: 10px 0;
      }
      .gh_skm{
        color: #858585;
      }
    }
    .content_img{
      width: 14px;margin-right: 10px;
      height: 14px;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/course/CourseHome.vue